import { PanelCallEpisodeStruct } from "../../structs/orchestrator-panel/panel-call-episode.struct";

export class CallPanelEpisodeRequest{
    public episodeData: PanelCallEpisodeStruct;
    public jsonListIdStatusQueue: string;
}